import CommonService from './common.service';
import { generateQueryParams } from 'utils';
import { _Object } from 'utils/interfaces';

class MediaService extends CommonService {
  async getMedia(params: _Object | string) {
    return await this.get(`media?${generateQueryParams(params)}`)
  }
  async getMediaDetails(id: string) {
    return await this.get(`media/${id}`)
  }
  async uploadMedia(parmas: FormData) {
    return await this.post('media', parmas)
  }
  async updateMedia(id: string, params: { [key: string]: boolean | string }) {
    return await this.put(`media/${id}`, params)
  }
  async deleteMedia(id: string) {
    return await this.delete(`media/${id}`)
  }
}
export const mediaService = new MediaService();